import Service from '@/service';
import QuestionService from '@/service/question';
import moUser from '@/store/user';
import { cloneDeep, isEmpty } from 'lodash';
import { observable, action, runInAction, toJS } from 'mobx';


const moQuestion = observable({
  prevtime: <any>'',
  curtime: <any>'',
  activeNum: <any>0,
  industryOpen: <any>false,
  industryCode: <any>null,
  subIndustryCode: <any>null,
  subIndustryName: <any>'',
  industry: <any>[],
  nature: <any>[],
  city: <any>[],
  scale: <any>[],
  cityCode: <any>null,
  scaleCode: <any>null,
  natureCode: <any>null,
  oneAnswer1: <any>'',
  oneAnswer2: <any>'',
  twoAnswer: <any>{
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
    seven: '',
    eight: '',
  },
  threeAnswer: <any>[],
  threeEdit: <any>'',
  fourAnswer: <any>'',
  fiveAnswer: <any>{
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
    seven: '',
    eight: '',
    nine: '',
    ten: '',
    eleven:'',
    twelve:'',
  },
  sixAnswer: <any>null,
  sevenAnswer: <any>{
    one: '',
    two: '',
  },
  eightAnswer: <any>{
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
    seven: '',
    eight: '',
    nine: '',
    ten: '',
  },
  nineAnswer: <any>[],
  nineEdit: <any>'',
  tenAnswer: <any>{
    one: '',
    two: '',
    three: '',
  },
  elevenAnswer: <any>[],
  elevenEdit: <any>'',
  twelveAnswer: <any>{
    one: '',
    two: '',
    three: '',
  },
  thirteenAnswer: <any>[],
  thirteenEdit: <any>'',
  fourteenAnswer: <any>[],
  fourteenEdit: <any>'',
  fifteenAnswer: <any>{
    one: '',
    two: '',
    three: '',
  },
});

// 第几题
const changeQuestion = action((val: number) => {
  runInAction(() => {
    moQuestion.activeNum = val;
  });
});

// 关闭弹框
const openModel = action((val: any) => {
  runInAction(() => {
    moQuestion.industryOpen = val;
  });
});

// 修改行业
const changeIndustry = action((item: any, code: any) => {
  openModel(false);
  runInAction(() => {
    moQuestion.industryCode = code;
    moQuestion.subIndustryCode = item.code;
    moQuestion.subIndustryName = item.name;
  });
});

// 修改城市
const changeCity = action((val: any) => {
  moQuestion.cityCode = val;
});

// 修改规模
const changeScale = action((val: any) => {
  moQuestion.scaleCode = val;
});

// 修改性质
const changeNature = action((val: any) => {
  moQuestion.natureCode = val;
});

// 修改第一题
const changeOne1 = action((val: any) => {
  runInAction(() => {
    moQuestion.oneAnswer1 = val;
  });
});

const changeOne2 = action((val: any) => {
  runInAction(() => {
    moQuestion.oneAnswer2 = val;
  });
});

// 修改第二题
const changeTwo = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.twoAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第三题
const changethree = action((val: any) => {
  runInAction(() => {
    if (moQuestion.threeAnswer.includes(val)) {
      const arr = [...moQuestion.threeAnswer].filter((res: any) => res !== val);
      moQuestion.threeAnswer = arr;
    } else {
      const arr = [...moQuestion.threeAnswer];
      arr.push(val);
      console.log(arr, 585);
      moQuestion.threeAnswer = arr;
    }
  });
});

const changeThreeEdit = action((val: any) => {
  runInAction(() => {
    moQuestion.threeEdit = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第四题
const changeFour = action((val: any) => {
  runInAction(() => {
    moQuestion.fourAnswer = val;
  });
});

// 修改第五题
const changeFive = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.fiveAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第六题
const changeSix = action((val: any) => {
  runInAction(() => {
    moQuestion.sixAnswer = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第七题
const changeSeven = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.sevenAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第八题
const changeEight = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.eightAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第九题
const changeNine = action((val: any) => {
  runInAction(() => {
    if (moQuestion.nineAnswer.includes(val)) {
      const arr = [...moQuestion.nineAnswer].filter((res: any) => res !== val);
      moQuestion.nineAnswer = arr;
    } else {
      const arr = [...moQuestion.nineAnswer];
      arr.push(val);
      moQuestion.nineAnswer = arr;
    }
  });
});

const changeNineEdit = action((val: any) => {
  runInAction(() => {
    moQuestion.nineEdit = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十题
const changeTen = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.tenAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十一题
const changeEleven = action((val: any) => {
  runInAction(() => {
    if (moQuestion.elevenAnswer.includes(val)) {
      const arr = [...moQuestion.elevenAnswer].filter((res: any) => res !== val);
      moQuestion.elevenAnswer = arr;
    } else {
      const arr = [...moQuestion.elevenAnswer];
      arr.push(val);
      moQuestion.elevenAnswer = arr;
    }
  });
});
const changeElevenEdit = action((val: any) => {
  runInAction(() => {
    moQuestion.elevenEdit = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十二题
const changeTwelve = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.twelveAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十三题
const changeThirteen = action((val: any) => {
  runInAction(() => {
    if (moQuestion.thirteenAnswer.includes(val)) {
      const arr = [...moQuestion.thirteenAnswer].filter((res: any) => res !== val);
      moQuestion.thirteenAnswer = arr;
    } else {
      const arr = [...moQuestion.thirteenAnswer];
      arr.push(val);
      moQuestion.thirteenAnswer = arr;
    }
  });
});

const changeThirteenEdit = action((val: any) => {
  runInAction(() => {
    moQuestion.thirteenEdit = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十四题
const changeFourteen = action((val: any) => {
  runInAction(() => {
    if (moQuestion.fourteenAnswer.includes(val)) {
      const arr = [...moQuestion.fourteenAnswer].filter((res: any) => res !== val);
      moQuestion.fourteenAnswer = arr;
    } else {
      const arr = [...moQuestion.fourteenAnswer];
      arr.push(val);
      moQuestion.fourteenAnswer = arr;
    }
  });
});

const changeFourteenEdit = action((val: any) => {
  runInAction(() => {
    moQuestion.fourteenEdit = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});

// 修改第十五题
const changeFifteen = action((val: any, type: string) => {
  runInAction(() => {
    moQuestion.fifteenAnswer[type] = val ? Number(val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')) : '';
  });
});



const questionInit = async () => {
  const time = new Date();
  const [result, answer, info] = await Promise.all([Service.base(), QuestionService.getAllAnswer(), QuestionService.getInfo()]);
  const year = time.getFullYear();
  const mouth = time.getMonth();
  const activetime = mouth >= 6 ? year : year - 1;
  const { city, scale, nature } = moUser;

  runInAction(() => {
    if (!isEmpty(info) && !isEmpty(info.industry)) {
      result?.industry.forEach((ele: any) => {
        ele.sub_industries.forEach((res: any) => {
          if (res.code === info.industry.code) {
            moQuestion.industryCode = ele.info.code || result?.industry[0].info.code;
          }
        });
      });
    } else {
      result?.industry.forEach((ele: any) => {
        ele.sub_industries.forEach((res: any) => {
          if (res.code === moUser.industry.code) {
            moQuestion.industryCode = ele.info.code || result?.industry[0].info.code;
          }
        });
      });
    }

    moQuestion.curtime = year - 1;
    moQuestion.prevtime = activetime;
    moQuestion.industry = result?.industry;
    moQuestion.nature = result?.nature;
    moQuestion.city = result?.city;
    moQuestion.scale = result?.scale;
    moQuestion.subIndustryCode = info?.industry?.code || moUser.industry?.code || result?.industry[0].sub_industries[0].code;
    moQuestion.subIndustryName = info?.industry?.name || moUser.industry?.name || result?.industry[0].sub_industries[0].name;
    moQuestion.cityCode = info?.city?.code || city?.code || result?.city[0].code;
    moQuestion.scaleCode = info?.scale?.code || scale?.code || result?.scale[0].code;
    moQuestion.natureCode = info?.nature?.code || nature?.code || result?.nature[0].code;
    if (!isEmpty(answer)) {
      answer.forEach((ele: any) => {
        if (ele.question === `${moQuestion.prevtime}年实际调薪频率`) {
          moQuestion.oneAnswer1 = ele.answer[0];
        }
        if (ele.question === `${moQuestion.prevtime + 1}年预计调薪频率`) {
          moQuestion.oneAnswer2 = ele.answer[0];
        }
        if (ele.question === '请填写本公司的调薪率') {
          moQuestion.twoAnswer = ele.answer;
        }
        if (ele.question === '根据哪些因素确定员工的调薪比例') {
          const result = ele.answer.map((item: any) => {
            let items = cloneDeep(item);
            if (item.includes('其他')) {
              const arr = items.split('-');
              items = arr[0];
              moQuestion.threeEdit = arr[1];
            }
            return items;
          });
          moQuestion.threeAnswer = result;
        }
        if (ele.question === '员工绩效分为几个等级') {
          moQuestion.fourAnswer = ele.answer[0];
        }
        if (ele.question === `${moQuestion.prevtime}年，不同绩效员工调薪率`) {
          moQuestion.fiveAnswer = ele.answer;
        }
        if (ele.question === '请提供晋升人员的平均调薪率') {
          moQuestion.sixAnswer = ele.answer.sixAnswer;
        }
        if (ele.question === `${moQuestion.prevtime}年员工离职率`) {
          moQuestion.sevenAnswer = ele.answer;
        }
        if (ele.question === `${moQuestion.prevtime}年各职能员工离职率`) {
          moQuestion.eightAnswer = ele.answer;
        }
        if (ele.question === '公司提供哪些津贴补贴') {
          const result = ele.answer.map((item: any) => {
            let items = cloneDeep(item);
            if (item.includes('其他')) {
              const arr = items.split('-');
              items = arr[0];
              moQuestion.nineEdit = arr[1];
            }
            return items;
          });
          moQuestion.nineAnswer = result;
        }
        if (ele.question === `${moQuestion.curtime}年津贴补贴占年固定薪酬的平均比例`) {
          moQuestion.tenAnswer = ele.answer;
        }
        if (ele.question === '公司提供哪些浮动薪酬') {
          const result = ele.answer.map((item: any) => {
            let items = cloneDeep(item);
            if (item.includes('其他')) {
              const arr = items.split('-');
              items = arr[0];
              moQuestion.elevenEdit = arr[1];
            }
            return items;
          });
          moQuestion.elevenAnswer = result;
        }
        if (ele.question === `${moQuestion.curtime}年浮动薪酬占年总现金收入的平均比例`) {
          moQuestion.twelveAnswer = ele.answer;
        }
        if (ele.question === '公司提供哪些长期激励') {
          const result = ele.answer.map((item: any) => {
            let items = cloneDeep(item);
            if (item.includes('其他')) {
              const arr = items.split('-');
              items = arr[0];
              moQuestion.thirteenEdit = arr[1];
            }
            return items;
          });
          moQuestion.thirteenAnswer = result;
        }
        if (ele.question === '公司为哪类员工提供长期激励') {
          const result = ele.answer.map((item: any) => {
            let items = cloneDeep(item);
            if (item.includes('其他')) {
              const arr = items.split('-');
              items = arr[0];
              moQuestion.fourteenEdit = arr[1];
            }
            return items;
          });
          moQuestion.fourteenAnswer = result;
        }
        if (ele.question === `${moQuestion.curtime}年，长期激励占比年总现金收入`) {
          moQuestion.fifteenAnswer = ele.answer;
        }
      });
    }
  });
};


export default moQuestion;
export {
  changeIndustry, questionInit, openModel, changeCity, changeScale, changeNature, changeQuestion, changeOne1,
  changeOne2, changeTwo, changethree, changeThreeEdit, changeFour, changeFive, changeSix,
  changeSeven, changeElevenEdit, changeEight, changeNine, changeNineEdit, changeTen, changeEleven, changeTwelve, changeThirteen,
  changeThirteenEdit, changeFourteen, changeFourteenEdit, changeFifteen,
};
